import { render, staticRenderFns } from "./EWTrxActivityTypeLogForm.vue?vue&type=template&id=f5ed28c0&"
import script from "./EWTrxActivityTypeLogForm.vue?vue&type=script&lang=js&"
export * from "./EWTrxActivityTypeLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports